import { useData } from '../../context/DataContext';
import './Stats.css';

export default function Stats() {
  const { data } = useData();
  const stats = data?.stats || [];

  return (
    <section className="stats">
      <div className="container">
        <div className="stats__grid">
          {stats.map(stat => (
            <div key={stat.id} className="stats__item">
              <div className="stats__value">{stat.value}</div>
              <div className="stats__label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
